import { ArrowBack } from "@mui/icons-material";
import { Box, Button, Grid2 as Grid, Stack } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { GetProfile } from "../queries/getProfile";
import { fetchQuery } from "../functions/misc";
import Loading from "../Common/Loading";
import { GetTaxRiskReports } from "../queries/GetTaxRiskReports";
import { getTaxRiskReport } from "../queries/getTaxRiskReport";
import { FeatureFlags } from "../types/featureFlags";
import { useFlags } from "launchdarkly-react-client-sdk";
import { GetProtectionPlanSubscription } from "../queries/GetProtectionPlanSubscription";
import BasicInformation from "../components/partner-client-info/basic-information";
import BillingStatus from "../components/partner-client-info/billing-status";
import DocumentsList from "../components/partner-client-info/documents-list";
import RecommendServices from "../components/partner-client-info/recommend-services";
import TaxRiskReportList from "../components/partner-client-info/tax-risk-report-list";
import MainLayout from "../layouts/main-layout";
import TaxShieldReports from "../components/TaxShield/reports/Reports";
import styled from "styled-components";



const PartnerClientInfo = ({ lead }: any) => {
    const [loading, setLoading] = useState(false);
    const [profileData, setProfileData] = useState<any>();
    const [taxReports, setTaxReports] = useState<any[]>([]);
    const [latestTaxReport, setLatestTaxReport] = useState<any>();
    const flagList: FeatureFlags = useFlags();
    const [subscriptionInfo, setSubscriptionInfo] = useState<any>();
    const [selectedReportId, setSelectedReportId] = useState<string | undefined>(undefined);
    const [showReport, setShowReport] = useState(false);
    const navigate = useNavigate();

    const getCompleteProfileInformation = async () => {
        setLoading(true);
        try {
            const profileId = lead.ProfileId;

            const getProfile: any = await fetchQuery({ profileId: profileId }, GetProfile);
            setProfileData(getProfile);

            const getSubscription = await fetchQuery({ ProfileId: profileId }, GetProtectionPlanSubscription);
            setSubscriptionInfo(getSubscription);

            const reportsData = await fetchQuery({ ProfileId: profileId }, GetTaxRiskReports);

            if (reportsData && reportsData.TaxRiskReports && reportsData.TaxRiskReports.length > 0) {
                setTaxReports(reportsData.TaxRiskReports);

                const latestReportId = reportsData.TaxRiskReports[0]?.Id;
                const latestReportData = await fetchQuery({ taxRiskReportId: latestReportId }, getTaxRiskReport);
                setLatestTaxReport(latestReportData);
            }
        } catch (error) {
            console.log("error: " + error);
        } finally {
            setLoading(false);
        }
    }


    const onActionHandler = () => { }

    const onReportSelectHandler = (reportId: any) => {
        setSelectedReportId(reportId);
        setShowReport(true);
    }

    const handleCloseReport = () => {
        setShowReport(false);
        setSelectedReportId(undefined);
    }

    useEffect(() => {
        console.log(lead);
        getCompleteProfileInformation();
    }, []);

    return (
        <MainLayout>
            {loading ? <Loading /> :
                <Box>
                    {!showReport &&
                        <div style={{ paddingRight: "24px" }}>
                            <h1 className="pageHeading">
                                {profileData?.FirstName + " " + profileData?.LastName}
                            </h1>
                        </div>}

                    {showReport ? (
                        <>
                            <div className="col-md-6" style={{
                                display: 'flex', justifyContent:
                                    'flex-end', paddingRight: "24px", width: "100%"
                            }}>
                                <Button variant="text" sx={{ color: '#212636', p: 0 }} onClick={handleCloseReport}>
                                    <ArrowBack fontSize='small' sx={{ marginRight: '0.25rem' }} />
                                    Back
                                </Button>
                            </div>
                            <TaxShieldReports reportId={selectedReportId} lead={lead} />
                        </>
                    ) : (
                        <Grid container spacing={2}>
                            <Grid size={{ sm: 12, md: 12, lg: 4 }} sx={{ mt: 3 }}>
                                <Stack spacing={3} sx={{ marginRight: '1rem' }}>
                                    <BasicInformation profileData={profileData} subscriptionInfo={subscriptionInfo} />
                                    {flagList.featurePartnerRecommendedServices &&
                                        <RecommendServices onAction={onActionHandler} />
                                    }
                                </Stack>
                            </Grid>
                            <Grid size={{ sm: 12, md: 12, lg: 8 }} sx={{ mt: 3 }}>
                                <Stack spacing={3}>
                                    <TaxRiskReportList
                                        lastestReportData={latestTaxReport}
                                        taxReports={taxReports}
                                        onReportClick={onReportSelectHandler}
                                    />
                                    <DocumentsList profileData={profileData} />
                                    <BillingStatus lead={lead} />
                                </Stack>
                            </Grid>
                            <Grid mt={5} sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                width: '100%',
                                marginTop: 'auto',
                            }}>
                                <TermSentence style={{ zIndex: 10, fontSize: 12 }} className="media-term-text">
                                    Copyright © Optima Tax Relief, LLC | All Rights Reserved
                                    <Dot>•</Dot>
                                    <ForgotPasswordLink
                                        href="https://optimataxrelief.com/about-us/terms-of-site/"
                                        target="_blank"
                                        rel="noreferrer"
                                        className="media-term-text"
                                    >
                                        Terms & Conditions{" "}
                                    </ForgotPasswordLink>
                                    <Dot>•</Dot>
                                    <ForgotPasswordLink
                                        href="https://optimataxrelief.com/about-us/privacy/"
                                        target="_blank"
                                        rel="noreferrer"
                                        className="media-term-text"
                                    >
                                        Privacy Policy
                                    </ForgotPasswordLink>
                                </TermSentence>
                            </Grid>
                        </Grid>
                    )}
                </Box>
            }
        </MainLayout>
    );
}

export default PartnerClientInfo;


const TermSentence = styled.div`
  align-items: center;
  text-align: center;
  margin: 2rem 1rem 2rem;
  color: #8E8E93;
`;

const ForgotPasswordLink = styled.a`
  text-decoration: none;
  cursor: pointer;
  margin-left: 3px;
  color: #1D89D2;
`;

const Dot = styled.span`
  margin-left: 3px;
`;